import QuickSelectOption from './QuickSelectOption';
import { P2GGrid } from '@parcel2go/core-ui';
import { SelectionOption } from './SelectionOption';
import { SelectionOptionGroup } from './SelectionOptionGroup';

interface props {
  isXs: boolean;
  group: SelectionOptionGroup;
  toggle: (o: SelectionOption, v: boolean) => void;
}

const QuickSelectSection = (props: props) =>
  props.isXs ? (
    <P2GGrid container spacing={1}>
      {props.group.items.map((o) => (
        <P2GGrid item xs={12} key={`${o.action}_${o.source}_${o.name}`}>
          <QuickSelectOption
            toggle={(v) => props.toggle(o, v)}
            selected={o.selected}
            source={o.source}
            provider={o.provider}
            isXs={props.isXs}
            total={o.total}
          >
            {o.name}
          </QuickSelectOption>
        </P2GGrid>
      ))}
    </P2GGrid>
  ) : (
    <div style={{ maxWidth: '800px' }}>
      <P2GGrid container>
        {props.group.items.map((o) => (
          <P2GGrid item key={`${o.action}_${o.source}_${o.name}`}>
            <div style={{ width: '180px' }}>
              <QuickSelectOption
                toggle={(v) => props.toggle(o, v)}
                selected={o.selected}
                source={o.source}
                provider={o.provider}
                isXs={props.isXs}
                total={o.total}
              >
                {o.name}
              </QuickSelectOption>
            </div>
          </P2GGrid>
        ))}
      </P2GGrid>
    </div>
  );

export default QuickSelectSection;
